import { Button } from "../../components/ui/Button";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import { Input } from "../../components/ui/Input";
import { IoShieldCheckmarkOutline } from "react-icons/io5";
import { maskCpf } from "../../util/mask";

export const AboutConsignadoINSS = ({
    cpf,
    setCpf,
    openPersonalDataModal,
    className = ""
}) => (<section id="AboutConsignadoINSS" className={`min-h-screen bg-[#ff6c00] text-white font-sans flex flex-col lg:flex-row ${className}`}>
    <div className="mt-20 w-full flex items-center justify-center">
        <div className="max-w-1/2 p-8 lg:pl-20 flex flex-col justify-center">
            <div className="w-full flex items-center justify-center">
                <div className="">
                    <h1 className="text-4xl lg:text-3xl font-bold leading-tight mb-4">
                        Desbloqueie já seu benefício no “Meu INSS”: <br />
                        <small className="text-sm text-white">
                            Ainda não desbloqueou?
                            <a className="underline hover:text-[#462A71] duration-500" href="https://www.gov.br/pt-br/temas/meu-inss"> Clique aqui </a> para desbloquear e garantir seu empréstimo.
                            É simples e rápido!</small>
                    </h1>

                    <p className="text-lg mb-4">
                        💸 Precisa de dinheiro com as menores taxas? O Consignado é pra você!
                    </p>

                    <ul className="mb-6 text-white space-y-2">
                        <li>✔ Liberação rápida e 100% online</li>
                        <li>✔ Até negativados são aceitos</li>
                        <li>✔ Parcelas descontadas direto da folha — sem dor de cabeça!</li>
                        <li>✔ Já são mais de 16 milhões de clientes no BMG</li>
                    </ul>

                    <p className="font-semibold text-white text-lg mb-2">
                        Simule o quanto você pode antecipar do seu FGTS:
                    </p>
                </div>
                <img className="hidden md:block w-[350px]" src="/assets/hero-benefit-blocked.png" alt="hero-benefit-blocked" />
            </div>
            <div className="flex flex-col md:flex-row">
                <div className="bg-white p-4 text-black w-full max-w-xl rounded-tl-[10px] rounded-tr-[10px] md:rounded-tl-[10px] md:rounded-tr-[0px] md:rounded-br-[0px] md:rounded-bl-[10px]">
                    <h1 className="flex items-center"><RiMoneyDollarCircleLine color="green" size={35} /> Simule agora mesmo!</h1>
                    <div className="mb-4 mt-4">
                        <Input
                            value={maskCpf(cpf)}
                            onChange={e => setCpf(e.target.value)}
                            label={'Qual seu Cpf?'}
                            placeholder={'XXX.XXX.XXX-XX'}
                            maxLength={14}
                            required={true}
                        />
                    </div>

                    <p className="text-xs text-gray-600 mb-2">
                        Empréstimo consignado para os aposentados e pensionistas do INSS. Sujeito à análise de crédito, margem consignável disponível e demais condições do Convênio. Utilize o crédito de forma consciente e somente em caso de necessidade.
                        * O prazo está sujeito a análise e é contabilizado a partir da aprovação de crédito.
                    </p>

                    <p className="text-xs text-gray-600">
                        O BMG exerce uma atividade prevista pelo Banco Central.
                    </p>
                </div>
                <div className="rounded-tr-[0px] rounded-tl-[0px] rounded-br-[10px] rounded-bl-[10px] md:rounded-tr-[10px] md:rounded-tl-[0px] md:rounded-br-[10px] md:rounded-bl-[0px]   lg:w-1/2 p-8 lg:pr-20 flex flex-col justify-center items-center bg-white text-black rounded-t-3xl lg:rounded-none">
                    <div className="hidden md:block bg-[#4b0082] text-white px-4 py-2 rounded-full mb-6">
                        <span className="flex items-center gap-2"><IoShieldCheckmarkOutline size={20} />Você está em ambiente seguro</span>
                    </div>
                    <Button onClick={openPersonalDataModal} className="w-1/2">
                        Simular empréstimo
                    </Button>
                </div>
            </div>
        </div>
    </div>
</section>)